import { useRef, useState } from 'react';
import { invoicesApi } from '../services/api';
import { formatNuf } from '../utils/formatNuf';
import { isCreditNote } from '../utils/invoiceDocument';

export default function useInvoicePdfDownload() {
  const pending = useRef(false);
  const [pdfDownloading, setPdfDownloading] = useState(null);
  const [pdfError, setPdfError] = useState('');

  const downloadPdf = async (invoice, { layout = 'standard', includeYear = false } = {}) => {
    if (!invoice?.id || pending.current) return;
    pending.current = true;
    setPdfError('');
    setPdfDownloading(layout);
    let url;
    try {
      const response = await invoicesApi.generatePdf(invoice.id, { layout });
      url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const year = includeYear && invoice.f_emission ? `_${new Date(invoice.f_emission).getFullYear()}` : '';
      const suffix = layout === 'payments' ? '_con_pagamenti' : '';
      link.download = `${isCreditNote(invoice) ? 'nota_credito' : 'fattura'}_${formatNuf(invoice.sezionale, invoice.nuf)}${year}${suffix}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      let message = error.response?.data?.message;
      if (!message && typeof error.response?.data?.text === 'function') {
        try { message = JSON.parse(await error.response.data.text()).message; } catch (_) { /* Use the download error below. */ }
      }
      setPdfError(message || 'Errore nel download del PDF. Riprova.');
    } finally {
      if (url) window.URL.revokeObjectURL(url);
      pending.current = false;
      setPdfDownloading(null);
    }
  };

  return { downloadPdf, pdfDownloading, pdfError, clearPdfError: () => setPdfError('') };
}
